import styled from '@emotion/styled';
import { tokens, Button, Link } from '@hotjar/hotsauce';

export const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
  margin-top: ${tokens.spacer.x4};
`;

export const SocialLink = styled(Button)`
  ${tokens.text('subtitle3')}
  text-decoration: auto;
  &:nth-of-type(1) {
    margin-right: ${tokens.spacer.x0};
  }
`;

export const StyledLink = styled(Link)`
  ${tokens.text('caption')}
`;

export const SubTitle = styled.h2`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};

  margin-bottom: ${tokens.spacer.x6};
`;

export const SubtitleEmail = styled.span`
  color: ${tokens.color.text_default};
`;

export const SocialLinksBlock = styled.div`
  margin-top: ${tokens.spacer.x6};
  margin-bottom: ${tokens.spacer.x2};
`;

export const VerificationFieldsWrapper = styled.div`
  input {
    width: 13% !important;
    height: ${tokens.spacer.x7};
  }
`;

export const RestartHelper = styled.p`
  ${tokens.text('caption')};
  color: ${tokens.color.text_light};
`;
